import type { Tier } from '@/lib/contract';
import { cn } from '@/lib/cn';

/** Vendor tier. Rendered as a bare letter, not a pill - it is a rank, not a status. */
export function TierBadge({ tier, className }: { tier: Tier; className?: string }) {
  if (!tier) return <span className={cn('text-dim', className)}>—</span>;
  return <span className={cn('text-[13px] text-foreground', className)}>{tier}</span>;
}
